import { render, staticRenderFns } from "./coupon-order-list.vue?vue&type=template&id=4344bd84&scoped=true&"
import script from "./coupon-order-list.vue?vue&type=script&lang=js&"
export * from "./coupon-order-list.vue?vue&type=script&lang=js&"
import style0 from "./coupon-order-list.vue?vue&type=style&index=0&id=4344bd84&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4344bd84",
  null
  
)

export default component.exports